import React from 'react'

const Btn = ({ innerText, bg, border, disable, onclick, active, inactive }) => {
    return (
        <button className={`mt-8 w-full h-12 rounded-3xl ${border ? "text-black" : "text-white"} font-Lato font-bold ${disable ? inactive : active} ${border ? border : ''}`} disabled={disable} onClick={onclick}>{innerText}</button>

    )
}

export default Btn